export class UserApiError extends Error {
	constructor(
		message: string,
		public error?: unknown,
		public code?: string,
		public status?: number,
		public details?: unknown,
	) {
		super(message);
		this.name = "UserApiError";
	}
}
